import { Skeleton } from "@/components/ui/skeleton";

export function RoutePending() {
  return (
    /* `max-w-full` on both: a 96 (384px) skeleton inside a p-6 measures 432
       against a 375px screen, so every route flashed a sideways scroll while
       it loaded and the page jumped as it settled. */
    <div className="space-y-4 p-4 sm:p-6">
      <Skeleton className="h-8 w-64 max-w-full" />
      <Skeleton className="h-4 w-96 max-w-full" />
      <Skeleton className="h-64 w-full rounded-xl" />
    </div>
  );
}
